/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Buffer } from 'buffer';

import { Component, useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { Modal, Button, Toast, Spinner } from 'react-bootstrap';

// project imports
import { FooterNew, Header, Sidebar } from '.';
import { AppRouter } from 'features/routers/AppRouter';
import { checkRefreshToken, isAuthorized, logout } from 'shared/settings/auth';
import store from 'features/store';
import { Register } from './../../register/Register';
import { Signin } from './../../signin/Signin';
import { ForgotPassword } from './../../forgot-password/ForgotPassword';

import { CheckExists } from 'features/components/register/CheckExists';
import ErrorModal from 'features/components/register/ErrorModal';
import NotificationModal from '../notification-modal/NotificationModal';

import { ErrorBoundary } from 'shared/utils';

import { MeasureConnectionSpeed } from 'shared/utils/SlowNetworDetect';
import Helmet from 'react-helmet';
import { CommonService } from 'shared/services';


// style imports
import './AppLayout.scss';
import { addDataLayer } from 'shared/utils/utils';
import pmservice from 'shared/services/pmservice';
import CommonMethods from 'shared/utils/CommonMethods';
import MembershipModal from '../auth-pages/MembershipModal/MembershipModal';
import { MobileAppBanner } from './MobileAppBanner';
import { HeaderNew } from './Header';
import Footer from './Footer';
import ExploreFilterUI from '../public/HOC/ExploreFilterUI';
import { crossIcon } from 'shared/assets/icons';

/**
 * main page layout after login is made
 * 
 * @param props
 * 
 * @returns renders the base layout after login
 * 
**/

class AppLayout extends Component {

    constructor(props) {
        super(props);

        this.state = {
            path: '',
            logoutModal: true,
            sessionModal: true,
            tempModal: false,
            showOffilePopUp: false,
            refreshLoading: false,
            downtimeWarningShow: false,
            bannerText: "<p class='text-center'>New look, New site, New items every day!</p>",
            bannerTextLoading: true,
            showHelmet: true,
            bannerImage: ''
        };
        this.retrySlowNetworkDetect = null;
        this.clearIntervel = null;
    }

    componentDidMount() {
        this.setBannerType(); // Set banner type based on login and membership status
        this.getWebContentText();
        setTimeout(() => {
            if (isAuthorized()) {
                if (!this.props.toggleSignInModal.open) {
                    const registerModalOpened = window.sessionStorage.getItem('registerModalOpened');
                    if (!registerModalOpened) {
                        if (window.innerWidth < 992) {
                            this.showAndHideJiraButton(true);
                        }
                        // store.dispatch({ type: 'TOGGLE_REGISTER_MODAL', payload: true });
                        // window.sessionStorage.setItem('registerModalOpened', true);
                    } 
                    // else {
                    //     window.sessionStorage.setItem('registerModalOpened', true);
                    // }
                } 
                // else {
                //     window.sessionStorage.setItem('registerModalOpened', true);
                // }
            } 
            // else {
            //     window.sessionStorage.setItem('registerModalOpened', true);
            // }
        }, 3000);
        window.addEventListener('online', () => this.toggleOnlinePopup(false), false);
        window.addEventListener('offline', () => this.toggleOnlinePopup(true), false);
        window.addEventListener('resize', this.handleResponsive);
        // this.removePreLoader();
        this.handleJiraButton();
    }

    componentDidUpdate(prevProps) {
        if (this.state.path !== this.props.history.location.pathname) {
            this.setState({ path: this.props.history.location.pathname });
            this.sidebarToggle();
            store.dispatch({ type: 'NETWORK_SLOW', payload: false });
            // const regexForNormal = /^\/estate-sale\/[^/]*[^/]*\/item\/[^/]*[^/]$/mgi;
            // const regexForPag = /^\/estate-sale\/[^/]*[^/]*\/item\/[^/]*[^/]*\/[^/]*$/mgi;
            // const checkItemView = regexForNormal.exec(this.props.history.location.pathname) || regexForPag.exec(this.props.history.location.pathname);
            // if (this.props.history.location.pathname === "/home" || checkItemView) {
            //     this.measureConnectionSpeed(true);
            // }

            const invoiceRegex = /^\/my-account\/invoice\/[^/]*[^/]*\/view[^/]*$/mgi;
            const invoiceView = invoiceRegex.exec(this.props.history.location.pathname);
            const runIntervel = ['/my-account/my-info/personal-info', '/my-account/my-info/change-password', '/my-account/my-info/tax-exemptions',
                '/my-account/invoice', '/my-account/notification-preferences', '/locations', '/my-account/won', '/my-account/not-won'];
            if (runIntervel.includes(this.props.history.location.pathname) || invoiceView) {
                this.clearIntervel = setInterval(() => {
                    console.clear();
                }, 1000);
            } else {
                if (this.clearIntervel) {
                    clearInterval(this.clearIntervel);
                }
            }
            const locationSalesRegex = /^\/locations\/[^/]*[^/]*\/sales[^/]*$/mgi;
            const locationSales = locationSalesRegex.exec(this.props.history.location.pathname);

            const estateSalesRegex = /^\/estate-sale\/(\d+)$/;
            const estateSalesList = estateSalesRegex.exec(this.props.history.location.pathname);

            const saleItemsRegex = /^\/estate-sale\/(\d+)\/item\/(\d+)\/(\b[a-zA-Z0-9 !-@#$%^&*)({}]+)/;
            const saleItems = saleItemsRegex.exec(this.props.history.location.pathname);

            const seoPages = ['/', '/estate-sale/list', '/advance-search', '/locations', '/ourstory', '/my-account/premier/member-benefits','/my-account/premier/total-access','/my-account/premier/alzheimers-foundation','/my-account/premier/advisor','/my-account/premier/auction-sneak-peak','/my-account/premier/delivery-guarantee','/my-account/premier/premier-account','/my-account/premier/worthpoint','/my-account/join-premier-member','/my-account/premier/premier-membership',"/plans","/premier-membership"]

            if (locationSales || seoPages.includes(this.props.history.location.pathname) || estateSalesList || saleItems) {
                this.setState({ showHelmet: false });
            } else {
                this.setState({ showHelmet: true });
            }
        }
        if (JSON.stringify(prevProps.user) !== JSON.stringify(this.props.user)) {
            this.handleJiraButton();
            // if (this.props.user.id && this.props.user.profilecompleted === 0 && this.props.user.deleteRequest === 0) {
            //     this.props.history.push('/my-account/my-info/personal-info');
            // }
            if (prevProps.user.id && !this.props.user.id) {
                const isPaymentScreen = this.props.history.location.pathname.includes("payment");
                logout(this.props.history, !this.props.sessionModal && !isPaymentScreen);
            }
        }
        if (prevProps.toggleSignInModal.open !== this.props.toggleSignInModal.open) {
            this.showAndHideJiraButton();
        }
        window.addEventListener('online', () => this.toggleOnlinePopup(false));
        window.addEventListener('offline', () => this.toggleOnlinePopup(true));
        window.addEventListener('resize', this.handleResponsive);
        if (JSON.stringify(prevProps.user) !== JSON.stringify(this.props.user)) {
            this.setBannerType();
            this.getWebContentText(); // Call API based on the updated banner type
        }
    }

    setBannerType = () => {
        if (!isAuthorized()) {
            this.bannerType = "CTBIDS_BANNERTEXT"; // Not logged in
        } else if (isAuthorized() && !this.props.user.membershipCompleted) {
            this.bannerType = 'CTBIDS_BANNERTEXT_NONPREMIER'; // Logged in, but not a Premier member
        } else if (isAuthorized() && this.props.user.membershipCompleted) {
            this.bannerType = 'CTBIDS_BANNERTEXT_PREMIER'; // Logged in and a Premier member
        }
    }
    

    /** Get Banner Text */
    getWebContentText = () => {
        CommonService.webContentText(this.bannerType).then(res => {
            const data = res.data.data[0];
            this.setState({
                bannerText: data ? data["description"] : this.state.bannerText,
                bannerTextLoading: false
            });
        }).catch(error => {
            this.setState({
                bannerTextLoading: false
            });
        });
    }


    /* this is used only in tablet and mobile devices to open or close sidebar */
    sidebarToggle = () => {
        store.dispatch({ type: 'TOGGLE_SIDEBAR', payload: false });
    };

    /* closes the logout modal box */
    logoutUser = (event) => {
        if (event) {
            logout(this.props.history);
        }

        store.dispatch({ type: 'TOGGLE_LOGOUT_MODAL', payload: false });
    };

    signIn = (event) => {
        const encoded = Buffer.from(this.props.history.location.pathname).toString("base64");
        if (event && !isAuthorized()) {
            const paramsValue = this.props.history.location.search;
            const decoded = Buffer.from(paramsValue, "base64").toString("ascii");
            if (!decoded) {
                logout(this.props.history, true, encoded);
            }
        }
        this.showAndHideJiraButton(true);
        store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: false });
        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: "Sign-In" } });
    }

    // tempModalLogin = () => {
    //     this.closeTempModal();
    //     store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });
    // }

    tempModalLogin = (flag) => {
        this.closeTempModal();
        store.dispatch({ type: 'TOGGLE_FORGOT_PASSWORD', payload: { open: true, mode: flag } });
    }

    removePreLoader = () => {
        const loader = document.querySelector('.pre-loader');
        const root = document.querySelector('.ct-bids');
        // console.log(loader, root);
        loader.classList.add('hide-loader');
        root.classList.add('loaded');
    }

    closeTempModal = () => {
        this.setState({
            tempModal: false
        });
    }

    toggleOnlinePopup = (flag) => {
        store.dispatch({ type: 'OFFLINE_POPUP', payload: flag });
    }

    refreshPage = () => {
        window.location.reload();
    }

    tokenRefresh = () => {
        this.setState({
            refreshLoading: true
        }, () => {
            checkRefreshToken().then(res => {
                // store.dispatch({ type: 'TOGGLE_REFRESH_MODAL', payload: false });
                this.setState({ refreshLoading: false });
            }).catch(err => {
                this.setState({ refreshLoading: false });
            });
        });

    }

    handleJiraButton = () => {
        const jsdWidget = document.querySelector("#jsd-widget");
        if (jsdWidget) {
            if (isAuthorized()) {
                jsdWidget.classList.add("login");
                jsdWidget.setAttribute("title", "Jira Chat Bot");
            } else {
                jsdWidget.classList.remove("login");
                jsdWidget.setAttribute("title", "Jira Chat Bot");
            }
        }
    }

    showAndHideJiraButton = (flag = false) => {
        const jsdWidget = document.querySelector("#jsd-widget");
        if (jsdWidget) {
            if (flag) {
                jsdWidget.classList.add("d-none");
            } else {
                this.props.toggleSignInModal.open ? jsdWidget.classList.add("d-none") : jsdWidget.classList.remove("d-none");
            }
        } else {
            setTimeout(() => {
                this.showAndHideJiraButton(flag);
            }, 1000);
        }
    }

    handleResponsive = () => {
        const scrollContainer = document.querySelector('.scroll-content');
        if (scrollContainer) {
            scrollContainer.scrollTop = 0;
        } else {
            window.scrollTo(0, 0);
        }
        if (window.innerWidth < 992) {
            if (this.props.toggleRegisterModal) {
                this.showAndHideJiraButton(true);
            }
        } else {
            if (this.props.toggleRegisterModal) {
                this.showAndHideJiraButton(false);
            }
        }
    }

    closeDownTimeWarning = () => {
        this.setState({
            downtimeWarningShow: false
        });
    }

    measureConnectionSpeed = (forceUpdate = false) => {
        if (this.props.history.location.pathname === '/' || forceUpdate) {
            MeasureConnectionSpeed().then(res => {
                if (res.speedKbps < 50) {
                    store.dispatch({ type: 'NETWORK_SLOW', payload: true });
                } else {
                    store.dispatch({ type: 'NETWORK_SLOW', payload: false });
                }
            }).catch(error => error);
        }
    }

    getBannerCount = () => {
        let dataLayerData = {
            'event': 'banner'
        }
        addDataLayer(dataLayerData)
    }

    componentWillUnmount() {
        window.removeEventListener('online', () => this.toggleOnlinePopup(false), false);
        window.removeEventListener('offline', () => this.toggleOnlinePopup(true), false);
        window.removeEventListener('resize', this.handleResponsive);
    }

    render() {

        return (
            <div className={`d-flex flex-column layout ${this.props.showOffilePopUp ? 'no-internet' : ''}`} style={{ overflowX: "hidden" }}>
                {
                    this.state.showHelmet ?
                        <Helmet>
                            <title>CTBids</title>
                            <meta name='description' content="CTBids buyers web app" />
                            <meta name="google-site-verification" content="PPiTWW_2xWSo19mPTsAyR2w2L4blIGf5dTyAmvknUrs" />
                            <link rel="canonical" href={`https://ctbids.com${this.state.path}`} />
                        </Helmet> : null
                }
                {
                    this.props.showOffilePopUp ? 
                    <Toast className="toast-handle">
                        <Toast.Body>Whoops! No internet connection found. Check your connection or <span className="clickable refresh-page" onClick={this.refreshPage}>Try Again</span></Toast.Body>
                    </Toast>: null
                }

                <MobileAppBanner />

                {/* // For Disable downtime warning enable first line and disable second line. /*}
                    {/* !isAuthorized() && this.props.header ? */}
                {/*  // this.props.header ? */}
                {
                    this.props.covidBanner ? !this.state.bannerTextLoading ?
                        <div className="covid-banner ql-editor" id="banner" dangerouslySetInnerHTML={{ __html: this.state.bannerText }} onClick={this.getBannerCount}>
                            {/* <i className="fas fa-exclamation-triangle"></i> */}

                            {/* Note:- For Disable warning enable first line and disable second line. */}
                            {/* New look, New site, New items every day! */}
                            {/* Payment Processing from 11pm EST on 5/13 to 5am EST on 5/14 may be impacted due to a scheduled maintenance window.  Please initiate payment outside of this window or contact Seller for more information.  */}
                        </div> : <div className="covid-banner p-3" id="banner">
                            <div className="snippet" data-title=".dot-elastic">
                                <div className="stage">
                                    <div className="dot-elastic"></div>
                                </div>
                            </div>
                        </div> : null
                }

                {
                    this.props.header ?
                        <div className={`top-layout animate__animated animate__fadeIn`}>
                            <Header {...this.props} onClick={this.helpSideBarHandle} />
                        </div>
                        : null
                }

                <div className="scroll-content">
                    <div className="d-flex flex-row middle-layout">
                        {
                            this.props['sidebar'] ?
                                <div className={`${this.props.toggleSidebar ? 'd-flex' : 'd-none'} d-lg-flex flex-row sidebar-layout mt2`}
                                    onClick={this.sidebarToggle}>
                                    <Sidebar {...this.props} />
                                </div> :
                                null
                        }
                        <div className={`d-flex flex-column content-layout ${this.props.sidebar ? 'content-layout-sidebar' : ''}`}  style={{ overflowX: "hidden" }}>
                            <ErrorBoundary {...this.props}>
                                <AppRouter />
                            </ErrorBoundary>
                        </div>
                    </div>
                    {/* {
                        this.props.footer ?
                            <div className="bottom-layout">
                                <Footer {...this.props} />
                            </div> : null
                    } */}
                </div>
                <Modal centered show={this.props.logoutModal} size="sm" animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            Are you sure you wish to signout?
                            <div className="d-flex flex-row mt-4">
                                <Button variant="outline-dark btn-white mx-2" style={{ width: '60px' }} onClick={() => this.logoutUser(false)}>No</Button>
                                <Button variant="secondary mx-2" style={{ width: '60px' }} onClick={() => this.logoutUser(true)}>Yes</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.props.sessionModal} size="sm" animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            Your session has expired. Please login.
                            <div className="d-flex flex-row mt-4">
                                <Button variant="secondary mx-2" style={{ width: '120px' }} onClick={() => this.signIn(true)}>Login</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.props.refreshModal} size="sm" animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            Oops, something went wrong... {isAuthorized() ? "Try to refresh the page, or log out and log in again." : "Try to refresh the page."}
                            <div className="d-flex flex-row mt-4">
                                <Button variant="secondary mx-2" style={{ width: '120px' }} onClick={() => this.tokenRefresh()} disabled={this.state.refreshLoading}>
                                    Refresh {this.state.refreshLoading ? <Spinner as="span" size='sm' animation='border' role='status' aria-hidden="true"></Spinner> : null}
                                </Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                {
                    this.props.toggleSuspendModal ?
                        <CommonMethods toggleSuspendModal={this.props.toggleSuspendModal}{...this.props}></CommonMethods> : null
                }
                {
                    this.props.toggleRegisterModal ?
                        <Register toggleRegisterModal={this.props.toggleRegisterModal}{...this.props}></Register> : null
                }
                {
                    this.props.toggleSignInModal?.open ?
                        <Signin toggleSignInModal={this.props.toggleSignInModal}{...this.props}></Signin> : null
                }
                {
                    this.props.toggleForgotPasswordModal?.open ?
                        <ForgotPassword toggleSignInModal={this.props.toggleSignInModal}{...this.props}></ForgotPassword> : null
                }
                {
                    this.props.checkExistsModal?.show ?
                        <CheckExists checkExistsModal={this.props.checkExistsModal}{...this.props}></CheckExists> : null
                }
                {
                    this.props.showErrorModal?.show ?
                        <ErrorModal showErrorModal={this.props.showErrorModal}{...this.props}></ErrorModal> : null
                }
                {

                    // this will be shown after sigin as a notification alert
                    this.props?.toggleNotificationModal?.show ? <NotificationModal {...this.props}/> : null
                }
                {
                    this.props?.membershipModal?.show ? <MembershipModal {...this.props} /> : null
                }
                {/* <Modal centered show={this.state.tempModal} animation={false} backdrop="static" keyboard={false} size="lg" onHide={this.closeTempModal}>
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body className="r-b temp-modal-css">
                        <div className="d-flex flex-column justify-content-center align-items-center temp-modal-container">
                            <div className="introduction text-center">
                                Welcome Back!
                            </div>
                            <div className="introduction">
                                If you are an <span className="fw-700">Existing Customer</span> and have not changed your <span className="break-line"></span>
                                password yet, click the button below and let's help you do that now
                            </div>
                            <div className="login-text introduction">
                                <span onClick={() => this.tempModalLogin('Existing-User')}>Reset Password</span>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="mb-6"></Modal.Footer>
                </Modal> */}
                <Modal centered show={this.state.downtimeWarningShow} size="lg" animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            CTBids will be undergoing maintenance on 7/01/2022 between 2.30 AM and 5.30 PM EST.
                            <div className="d-flex flex-row mt-4">
                                <Button variant="secondary mx-2" style={{ width: '120px' }} onClick={() => this.closeDownTimeWarning()}>
                                    Close
                                </Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

// export default connect(state => state)(AppLayout);


const AppLayoutNew = (props) => {

    const reduxState = useSelector(state => state);

    const [showHelmet, setShowHelmet] = useState(true);
    const [refreshLoading, setRefreshLoading] = useState(false);

    useEffect(() => {
        window.addEventListener('online', () => toggleOnlinePopup(false), false);
        window.addEventListener('offline', () => toggleOnlinePopup(true), false);

        return () => {
            window.removeEventListener('online', () => toggleOnlinePopup(false), false);
            window.removeEventListener('offline', () => toggleOnlinePopup(true), false);
        }
    }, []);


    useEffect(() => {
        const scrollContainer = document.querySelector('.scroll-content');
        if (scrollContainer) {
            scrollContainer.scrollTop = 0;
        } else {
            window.scrollTo(0, 0);
        }
    }, [props.location.pathname]);
    
    useEffect(() => {
        store.dispatch({ type: 'TOGGLE_SIDEBAR', payload: false });

        const pathName = props.location.pathname;

        const locationSalesRegex = /^\/locations\/[^/]*[^/]*\/sales[^/]*$/mgi;
        const locationSales = locationSalesRegex.exec(pathName);

        const estateSalesRegex = /^\/estate-sale\/(\d+)$/;
        const estateSalesList = estateSalesRegex.exec(pathName);

        const saleItemsRegex = /^\/estate-sale\/(\d+)\/item\/(\d+)\/(\b[a-zA-Z0-9 !-@#$%^&*)({}]+)/;
        const saleItems = saleItemsRegex.exec(pathName);

        const seoPages = ['/', '/estate-sale/list', '/locations', '/ourstory', '/my-account/premier/member-benefits', '/my-account/premier/total-access', '/my-account/premier/alzheimers-foundation', '/my-account/premier/advisor', '/my-account/premier/auction-sneak-peak', '/my-account/premier/delivery-guarantee', '/my-account/premier/premier-account', '/my-account/premier/worthpoint', '/my-account/join-premier-member', '/my-account/premier/premier-membership', "/plans"];

        if (locationSales || seoPages.includes(pathName) || estateSalesList || saleItems) {
            setShowHelmet(false);
        } else {
            setShowHelmet(true);
        }
    }, [props.location.pathname]);

    const toggleOnlinePopup = (flag) => {
        store.dispatch({ type: 'OFFLINE_POPUP', payload: flag });
    }

    const toggleSideBar = () => {
        store.dispatch({ type: 'TOGGLE_SIDEBAR', payload: false });
    };

    const tokenRefresh = () => {
        setRefreshLoading(true);
        checkRefreshToken().then(res => {
            // store.dispatch({ type: 'TOGGLE_REFRESH_MODAL', payload: false });
            setRefreshLoading(true);
        }).catch(err => {
            setRefreshLoading(true);
        });
    };

    const signIn = (event) => {
        const encoded = Buffer.from(props.history.location.pathname).toString("base64");
        if (event && !isAuthorized()) {
            const paramsValue = props.history.location.search;
            const decoded = Buffer.from(paramsValue, "base64").toString("ascii");
            if (!decoded) {
                logout(props.history, true, encoded);
            }
        }
        store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: false });
        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: "Sign-In" } });
    }

    const closeSessionModel = () =>{
        store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: false })
    }

    const logoutUser = (event) => {
        if (event) {
            logout(props.history);
        }

        store.dispatch({ type: 'TOGGLE_LOGOUT_MODAL', payload: false });
    };

    return (
        <div className={`d-flex flex-column layout ${reduxState.showOffilePopUp ? 'no-internet' : ''}`} style={{ overflowX: "hidden" }}>
            {
                showHelmet ?
                <Helmet>
                    <title>CTBids</title>
                    <meta name='description' content="CTBids buyers web app" />
                    <meta name="google-site-verification" content="PPiTWW_2xWSo19mPTsAyR2w2L4blIGf5dTyAmvknUrs" />
                    <link rel="canonical" href={`https://ctbids.com${props.history.location.pathname}`} />
                </Helmet> : null
            }
            {
                reduxState.showOffilePopUp ? 
                <Toast className="toast-handle">
                    <Toast.Body>Whoops! No internet connection found. Check your connection or <span className="clickable refresh-page" onClick={() => { window.location.reload(); }}>Try Again</span></Toast.Body>
                </Toast>: null
            }

            <MobileAppBanner />

            {
                reduxState.header ?
                <div className={`top-layout ${reduxState.user.id ? 'setHeight' : ''} `}>
                    <HeaderNew {...props} />
                </div>
                : null
            }

            <div className="scroll-content">
                <ErrorBoundary {...props}>
                    <AppRouter />
                </ErrorBoundary>
                {
                    reduxState.footer && !props.location?.pathname.includes('/my-account') ?
                    <div className="bottom-layout">
                        <FooterNew {...props} />
                    </div> : null
                }
            </div>

            <Modal centered show={reduxState.logoutModal} size="sm" animation={false} backdrop="static" keyboard={false}>
                <Modal.Body>
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        Are you sure you wish to signout?
                        <div className="d-flex flex-row mt-4">
                            <Button variant="outline-dark btn-white mx-2" style={{ width: '60px' }} onClick={() => logoutUser(false)}>No</Button>
                            <Button variant="btn btn-secondary" style={{ width: '60px' }} onClick={() => logoutUser(true)}>Yes</Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal centered show={reduxState.sessionModal} size="sm" animation={false} backdrop="static" keyboard={false}>
                <Modal.Body>
                <div className="w-100 d-flex justify-content-end" style={{ marginBottom: "10px" }}>
                        <img role='button' src={`${process.env.PUBLIC_URL}/static/icons/common-icons/close.svg`} alt="Close button"  style={{ width: "20px" }} onClick={() => closeSessionModel()} />
                    </div>
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        Your session has expired. Please login.
                        <div className="d-flex flex-row mt-4">
                            <Button variant="secondary mx-2" style={{ width: '120px' }} onClick={() => signIn(true)}>Login</Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal centered show={reduxState.refreshModal} size="sm" animation={false} backdrop="static" keyboard={false}>
                <Modal.Body>
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        Oops, something went wrong... {isAuthorized() ? "Try to refresh the page, or log out and log in again." : "Try to refresh the page."}
                        <div className="d-flex flex-row mt-4">
                            <Button variant="secondary mx-2" style={{ width: '120px' }} onClick={tokenRefresh} disabled={refreshLoading}>
                                Refresh {refreshLoading ? <Spinner as="span" size='sm' animation='border' role='status' aria-hidden="true"></Spinner> : null}
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {
                reduxState.toggleSuspendModal ?
                <CommonMethods toggleSuspendModal={reduxState.toggleSuspendModal} {...props}></CommonMethods> : null
            }
            {
                reduxState.toggleRegisterModal ?
                <Register toggleRegisterModal={reduxState.toggleRegisterModal} {...props}></Register> : null
            }
            {
                reduxState.toggleSignInModal?.open ?
                <Signin toggleSignInModal={reduxState.toggleSignInModal} {...props}></Signin> : null
            }
            {
                reduxState.toggleForgotPasswordModal?.open ?
                <ForgotPassword toggleSignInModal={reduxState.toggleSignInModal} {...props}></ForgotPassword> : null
            }
            {
                reduxState.checkExistsModal?.show ?
                <CheckExists checkExistsModal={reduxState.checkExistsModal} {...props}></CheckExists> : null
            }
            {
                reduxState.showErrorModal?.show ?
                    <ErrorModal showErrorModal={reduxState.showErrorModal} {...props}></ErrorModal> : null
            }
            {
                // this will be shown after sigin as a notification alert
                reduxState.toggleNotificationModal?.show ? <NotificationModal {...props}/> : null
            }
            {
                reduxState.membershipModal?.show ? <MembershipModal {...props} /> : null
            }
            <Modal centered show={reduxState?.exploreModal} size="lg" animation={false} backdrop="static" keyboard={false} className={"explore-modal"}>
                <Modal.Header className='d-flex justify-content-between'>
                    <div>

                        <div className="exploreHead">Find your next treasure...</div>
                        <div className="exploresubhead">Select options to browse a selection of items.</div>
                    </div>
                    <div role={"button"} onClick={()=>{
                         store.dispatch({ type: 'EXPLORE_MODAL', payload: false });
                    }}>
                      {crossIcon}
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <ExploreFilterUI 
                    onApply={(filter) => {
                        store.dispatch({ type: 'EXPLORE_MODAL', payload: false });
                        props.history.push(`/explore`, { filter: filter });
                    }}
                        filterData={{}}
                      />
                </Modal.Body>
            </Modal>
        </div>
    )
};
export default connect(state => state)(AppLayoutNew);